// src/main/PaymentHistory.js

import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
    Container,
    Typography,
    Button,
    Paper,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Chip,
    Grid,
    Slide,
    MenuItem,
    InputLabel,
    FormControl,
    Select,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Divider,
    useTheme,
    InputAdornment,
    Menu,
    Tooltip,
    Card,
    CardContent,
    CardActions,
    Tabs,
    Tab,
    Avatar,
    LinearProgress,
    Stack,
    Alert,
    Snackbar,
    FormControlLabel,
    Switch,
    Stepper,
    Step,
    StepLabel,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Breadcrumbs,
    Link,
    Fab,
    Zoom,
    Badge,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Timeline,
    TimelineItem,
    TimelineSeparator,
    TimelineDot,
    TimelineConnector,
    TimelineContent,
    TimelineOppositeContent,
    StepIcon,
    StepConnector,
    styled,
    Rating,
    CircularProgress,
    Backdrop,
    LinearProgress as MuiLinearProgress
} from '@mui/material';
import {
    Delete,
    Search,
    Add as AddIcon,
    Close as CloseIcon,
    Filter as FilterIcon,
    Refresh as RefreshIcon,
    Edit as EditIcon,
    Visibility as ViewIcon,
    Apartment as ApartmentIcon,
    Home as HomeIcon,
    LocationOn,
    Business,
    FormatListNumbered,
    PictureAsPdf,
    TableChart,
    GetApp,
    Print,
    MeetingRoom,
    Build,
    CheckCircle,
    Cancel,
    People,
    AttachMoney,
    TrendingUp,
    TrendingDown,
    MoreVert,
    Dashboard as DashboardIcon,
    List as ListIcon,
    Store as StoreIcon,
    Phone,
    Email,
    Person,
    Assignment,
    Map as MapIcon,
    ViewModule,
    ViewList,
    ExpandMore,
    NavigateNext,
    AddCircleOutline,
    RemoveCircleOutline,
    Warning,
    CheckBox,
    RadioButtonChecked,
    BedroomParent,
    Bathtub,
    SquareFoot,
    Kitchen,
    LocalParking,
    Elevator,
    Security,
    Wifi,
    AcUnit,
    LocalLaundryService,
    Pool,
    EventNote,
    Receipt,
    History,
    MoveToInbox,
    ExitToApp,
    Gavel,
    VerifiedUser,
    CreditCard,
    CalendarToday,
    Description,
    Note,
    AttachFile,
    CloudUpload,
    Key,
    AssignmentInd,
    HowToReg,
    PersonAdd,
    SwapHoriz,
    CheckCircleOutline,
    ReceiptLong,
    QrCodeScanner,
    AccountBalance,
    PhoneAndroid,
    CreditCard as CreditCardIcon,
    LocalAtm,
    Print as PrintIcon,
    Download,
    VisibilityOff,
    Verified,
    Pending,
    Error as ErrorIcon,
    Receipt as ReceiptIcon
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import useCustomToast from '../../hooks/useToast';
import {
    APIPropertyList,
    APIApartmentList,
    APIFloorUnitList,
    APITenantList,
    APIAssignmentList,
    APIPaymentList,
    APIPaymentStore,
    APIPaymentUpdate,
    APIPaymentDelete,
    APIPaymentExportExcel,
    APIPaymentExportPDF,
    APIPaymentPrint,
    APIPaymentStats,
    APIPaymentReceipt,
    APIPaymentVerify,
    APIPaymentInvoice
} from '../../apiServices/APIs';
import { formatCreatedAtDate, recordsCount, recordsPerPage } from '../../utils/helpers';
import { getUserDetails } from '../../utils/helpers';
import { apiService } from '../../apiServices/ApiService';
import ErrorState from '../../components/ErrorrState';
import LoadingState from '../../components/LoadingState';
import { usePermission } from '../../hooks/usePermission';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const PaymentHistory = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const showToast = useCustomToast();
    const [updateId, setUpdateId] = useState('');
    const [postStatus, setPostStatus] = useState('ADD');
    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    const [pageState, setPageState] = useState({
        pageData: [],
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(recordsPerPage);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [statistics, setStatistics] = useState(null);
    const [properties, setProperties] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState('');
    const [selectedTenant, setSelectedTenant] = useState('');
    const [receiptPreviewOpen, setReceiptPreviewOpen] = useState(false);
    const [receiptUrl, setReceiptUrl] = useState('');
    const [verifyDialogOpen, setVerifyDialogOpen] = useState(false);
    const [verificationNotes, setVerificationNotes] = useState('');

    // Use ref to track if component is mounted
    const isMounted = useRef(true);

    // Payment method options
    const paymentMethodOptions = [
        { id: 'cash', name: 'Cash', icon: <LocalAtm />, color: 'success' },
        { id: 'bank_transfer', name: 'Bank Transfer', icon: <AccountBalance />, color: 'primary' },
        { id: 'card', name: 'Card', icon: <CreditCardIcon />, color: 'secondary' },
        { id: 'mobile_money', name: 'Mobile Money', icon: <PhoneAndroid />, color: 'warning' },
        { id: 'check', name: 'Check', icon: <ReceiptIcon />, color: 'info' }
    ];

    // Payment status options
    const paymentStatusOptions = [
        { id: 'completed', name: 'Completed', color: 'success', icon: <CheckCircle /> },
        { id: 'failed', name: 'Failed', color: 'error', icon: <ErrorIcon /> },
        { id: 'pending_verification', name: 'Pending Verification', color: 'warning', icon: <Pending /> }
    ];

    // Form data for Payment
    const [formData, setFormData] = useState({
        tenant_id: '',
        assignment_id: '',
        payment_date: new Date().toISOString().slice(0, 16),
        amount: '',
        payment_method: '',
        transaction_reference: '',
        payment_status: 'pending_verification',
        notes: '',
        receipt_file: null
    });

    const [filters, setFilters] = useState({
        payment_status: '',
        payment_method: '',
        tenant_id: '',
        property_id: '',
        date_from: '',
        date_to: '',
        min_amount: '',
        max_amount: ''
    });

    const [errors, setErrors] = useState({
        tenant_id: false,
        amount: false,
        payment_method: false,
        payment_date: false
    });

    // State for dialogs
    const [filterOptions, setFilterOptions] = useState(false);
    const [openAdd, setOpenAdd] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
    const [uploading, setUploading] = useState(false);

    // Use the updated permission hook
    const { hasPermission, loading: permissionLoading } = usePermission();

    useEffect(() => {
        isMounted.current = true;
        apiService.setToastFunction(showToast);
        fetchProperties();
        fetchTenants();
        fetchAssignments();
        fetchPayments();
        fetchStatistics();

        return () => {
            isMounted.current = false;
        };
    }, [showToast]);

    // Fetch properties for dropdown
    const fetchProperties = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIPropertyList);
            if (result.success && isMounted.current) {
                setProperties(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.error("Error fetching properties:", error);
        }
    };

    // Fetch tenants
    const fetchTenants = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APITenantList);
            if (result.success && isMounted.current) {
                setTenants(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.error("Error fetching tenants:", error);
            if (isMounted.current) setTenants([]);
        }
    };

    // Fetch assignments for selected tenant
    const fetchAssignments = async (tenantId = null) => {
        try {
            const userBranchId = getUserDetails("branchId");
            const params = { assignment_status: 'active' };
            if (tenantId) params.tenant_id = tenantId;
            
            const result = await apiService.list(userBranchId, APIAssignmentList, params);
            if (result.success && isMounted.current) {
                setAssignments(Array.isArray(result.data) ? result.data : []);
            }
        } catch (error) {
            console.error("Error fetching assignments:", error);
            if (isMounted.current) setAssignments([]);
        }
    };

    // Fetch payments
    const fetchPayments = async () => {
        setLoading(true);
        setError(null);

        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.list(userBranchId, APIPaymentList);

            if (result.success && isMounted.current) {
                const payments = Array.isArray(result.data) ? result.data.reverse() : [];
                setPageState(prev => ({
                    ...prev,
                    pageData: payments
                }));
            } else if (isMounted.current) {
                setError(result.message);
            }
        } catch (error) {
            if (isMounted.current) {
                setError("Failed to load data");
            }
            console.error("Fetch error:", error);
        } finally {
            if (isMounted.current) {
                setLoading(false);
            }
        }
    };

    // Fetch statistics
    const fetchStatistics = async () => {
        try {
            const userBranchId = getUserDetails("branchId");
            const result = await apiService.listStats(userBranchId, APIPaymentStats);
            if (result.success && result.data && isMounted.current) {
                setStatistics(result.data);
            }
        } catch (error) {
            console.error("Error fetching statistics:", error);
        }
    };

    // Export handlers
    const handleExportClick = (event) => { setExportAnchorEl(event.currentTarget); };
    const handleExportClose = () => { setExportAnchorEl(null); };
    
    const handlePrint = async (record) => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to print payment receipts", "error");
            return;
        }
        
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('print_id', record.id);
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));

            const result = await apiService.print(APIPaymentPrint, formDataToSend);

            if (result && result.success && isMounted.current) {
                showToast("Success", "Receipt generated successfully", "success");
            } else if (isMounted.current) {
                showToast("Error", result.message || "Failed to generate receipt", "error");
            }
        } catch (error) {
            console.error("Print error:", error);
            if (isMounted.current) {
                showToast("Error", "Failed to generate receipt", "error");
            }
        }
    };
    
    const handleExportExcel = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export payment data", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing Excel export...", "info");
            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToExcel(APIPaymentExportExcel, formDataToSend);
            if (result && result.success && isMounted.current) {
                showToast("Success", "Excel file downloaded successfully", "success");
            } else if (isMounted.current) {
                showToast("Error", result.message || "Failed to export Excel file", "error");
            }
        } catch (error) {
            console.error('Excel export error:', error);
            if (isMounted.current) {
                showToast("Error", error.message || "Failed to export Excel file", "error");
            }
        }
    };

    const handleExportPDF = async () => {
        if (!hasPermission('EXPORT')) {
            showToast("Permission Denied", "You don't have permission to export payment data", "error");
            handleExportClose();
            return;
        }
        
        try {
            handleExportClose();
            showToast("Processing", "Preparing PDF export...", "info");

            const formDataToSend = new FormData();
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_name', getUserDetails("userName"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.exportToPDF(APIPaymentExportPDF, formDataToSend);

            if (result && result.success && isMounted.current) {
                showToast("Success", "PDF file downloaded successfully", "success");
            } else if (isMounted.current) {
                showToast("Error", result.message || "Failed to export PDF file", "error");
            }
        } catch (error) {
            console.error('PDF export error:', error);
            if (isMounted.current) {
                showToast("Error", error.message || "Failed to export PDF file", "error");
            }
        }
    };

    const handleGenerateReceipt = async (record) => {
        if (!hasPermission('PRINT')) {
            showToast("Permission Denied", "You don't have permission to generate receipts", "error");
            return;
        }

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('payment_id', record.id);
            formDataToSend.append('branch_id', getUserDetails("branchId"));
            formDataToSend.append('user_id', getUserDetails("Id"));
            const result = await apiService.print(APIPaymentReceipt, formDataToSend);
            if (result && result.success && isMounted.current) {
                showToast("Success", "Receipt generated successfully", "success");
            }
        } catch (error) {
            console.error("Receipt generation error:", error);
            if (isMounted.current) {
                showToast("Error", "Failed to generate receipt", "error");
            }
        }
    };

    const handleViewReceipt = (record) => {
        if (record.receipt_url) {
            setReceiptUrl(record.receipt_url);
            setReceiptPreviewOpen(true);
        } else {
            showToast("Info", "No receipt file available", "info");
        }
    };

    const handleVerifyPayment = (record) => {
        if (record.payment_status !== 'pending_verification') {
            showToast("Info", "Only pending payments can be verified", "info");
            return;
        }
        setSelectedRecord(record);
        setVerificationNotes('');
        setVerifyDialogOpen(true);
    };

    const handleCloseReceiptPreview = () => {
        setReceiptPreviewOpen(false);
        setReceiptUrl('');
    };

    const handleCloseVerify = () => {
        setVerifyDialogOpen(false);
        setVerificationNotes('');
    };

    const handleVerifySubmit = async () => {
        const formDataToSend = new FormData();
        formDataToSend.append('user_id', getUserDetails("Id"));
        formDataToSend.append('branch_id', getUserDetails("branchId"));
        formDataToSend.append('payment_id', selectedRecord.id);
        formDataToSend.append('verification_notes', verificationNotes);

        try {
            const result = await apiService.create(APIPaymentVerify, formDataToSend);
            if (result && result.success && isMounted.current) {
                showToast("Success", result.message, "success");
                handleCloseVerify();
                fetchPayments();
                fetchStatistics();
            }
        } catch (error) {
            console.error("Verification error:", error);
            if (isMounted.current) {
                showToast("Error", "Failed to verify payment", "error");
            }
        }
    };

    // Filter based on search term and filters with useMemo
    const filteredData = useMemo(() => {
        return pageState.pageData.filter(record => {
            const matchesSearch = searchTerm === '' ||
                record.tenant_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                record.payment_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                record.transaction_reference?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                record.tenant_phone?.includes(searchTerm);

            const matchesStatus = !filters.payment_status || 
                record.payment_status === filters.payment_status;

            const matchesMethod = !filters.payment_method || 
                record.payment_method === filters.payment_method;

            const matchesTenant = !filters.tenant_id || 
                record.tenant_id?.toString() === filters.tenant_id;

            const matchesProperty = !filters.property_id || 
                record.property_id?.toString() === filters.property_id;

            const matchesMinAmount = !filters.min_amount ||
                (record.amount && record.amount >= parseFloat(filters.min_amount));

            const matchesMaxAmount = !filters.max_amount ||
                (record.amount && record.amount <= parseFloat(filters.max_amount));

            let matchesDate = true;
            if (filters.date_from && record.payment_date) {
                matchesDate = matchesDate && record.payment_date >= filters.date_from;
            }
            if (filters.date_to && record.payment_date) {
                matchesDate = matchesDate && record.payment_date <= filters.date_to;
            }

            return matchesSearch && matchesStatus && matchesMethod && 
                   matchesTenant && matchesProperty && matchesMinAmount && 
                   matchesMaxAmount && matchesDate;
        });
    }, [pageState.pageData, searchTerm, filters]);

    // Pagination handlers
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Dialog handlers
    const handlefilterOptions = () => setFilterOptions(true);
    const handleCloseOptions = () => setFilterOptions(false);

    const handleOpenAdd = () => {
        if (!hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to record payments", "error");
            return;
        }

        setPostStatus("ADD");
        setFormData({
            tenant_id: '',
            assignment_id: '',
            payment_date: new Date().toISOString().slice(0, 16),
            amount: '',
            payment_method: '',
            transaction_reference: '',
            payment_status: 'pending_verification',
            notes: '',
            receipt_file: null
        });
        setErrors({
            tenant_id: false,
            amount: false,
            payment_method: false,
            payment_date: false
        });
        setOpenAdd(true);
    };

    const handleCloseAdd = () => {
        setOpenAdd(false);
    };

    const handleOpenView = (record) => {
        setSelectedRecord(record);
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleOpenEdit = (record) => {
        if (!hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to edit payments", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("UPDATE");

        setFormData({
            tenant_id: record.tenant_id || '',
            assignment_id: record.assignment_id || '',
            payment_date: record.payment_date || '',
            amount: record.amount || '',
            payment_method: record.payment_method || '',
            transaction_reference: record.transaction_reference || '',
            payment_status: record.payment_status || 'pending_verification',
            notes: record.notes || '',
            receipt_file: null
        });
        fetchAssignments(record.tenant_id);
        setOpenAdd(true);
    };

    const handleOpenDelete = (record) => {
        if (!hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete payments", "error");
            return;
        }

        setSelectedRecord(record);
        setUpdateId(record.id);
        setPostStatus("DELETE");
        setOpenDelete(true);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
    };

    // Form handlers
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setErrors(prev => ({
            ...prev,
            [name]: false
        }));

        if (name === 'tenant_id') {
            fetchAssignments(value);
            setFormData(prev => ({
                ...prev,
                [name]: value,
                assignment_id: ''
            }));
            return;
        }

        if (name === 'assignment_id') {
            const selectedAssignment = assignments.find(a => a.id.toString() === value);
            if (selectedAssignment) {
                setFormData(prev => ({
                    ...prev,
                    [name]: value,
                    amount: selectedAssignment.agreed_rent_amount || prev.amount
                }));
                return;
            }
        }

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'application/pdf') {
            setFormData(prev => ({
                ...prev,
                receipt_file: file
            }));
        } else {
            showToast("Error", "Please upload a valid PDF file", "error");
        }
    };

    // Filter handlers
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const clearFilters = () => {
        setFilters({
            payment_status: '',
            payment_method: '',
            tenant_id: '',
            property_id: '',
            date_from: '',
            date_to: '',
            min_amount: '',
            max_amount: ''
        });
        setSearchTerm('');
        setSelectedProperty('');
        setSelectedTenant('');
        handleCloseOptions();
    };

    const applyFilters = () => {
        handleCloseOptions();
    };

    const validateForm = () => {
        if (!formData.tenant_id) {
            showToast("Validation Error", "Please select a tenant", "warning");
            return false;
        }
        if (!formData.amount || formData.amount <= 0) {
            showToast("Validation Error", "Amount is required and must be greater than 0", "warning");
            return false;
        }
        if (!formData.payment_method) {
            showToast("Validation Error", "Please select a payment method", "warning");
            return false;
        }
        if (!formData.payment_date) {
            showToast("Validation Error", "Payment date is required", "warning");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (postStatus === "ADD" && !hasPermission('ADD')) {
            showToast("Permission Denied", "You don't have permission to record payments", "error");
            return;
        }
        
        if (postStatus === "UPDATE" && !hasPermission('EDIT')) {
            showToast("Permission Denied", "You don't have permission to update payments", "error");
            return;
        }
        
        if (postStatus === "DELETE" && !hasPermission('DELETE')) {
            showToast("Permission Denied", "You don't have permission to delete payments", "error");
            return;
        }
        
        if (postStatus !== "DELETE") {
            if (!validateForm()) return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('user_id', getUserDetails("Id"));
        formDataToSend.append('branch_id', getUserDetails("branchId"));

        if (postStatus !== "DELETE") {
            formDataToSend.append('tenant_id', formData.tenant_id);
            formDataToSend.append('assignment_id', formData.assignment_id);
            formDataToSend.append('payment_date', formData.payment_date);
            formDataToSend.append('amount', formData.amount);
            formDataToSend.append('payment_method', formData.payment_method);
            formDataToSend.append('transaction_reference', formData.transaction_reference || '');
            formDataToSend.append('payment_status', formData.payment_status);
            formDataToSend.append('notes', formData.notes || '');
            
            if (formData.receipt_file) {
                formDataToSend.append('receipt_file', formData.receipt_file);
            }
        }

        if (postStatus === "UPDATE" || postStatus === "DELETE") {
            formDataToSend.append('updateId', updateId);
        }

        setUploading(true);
        try {
            let result;
            if (postStatus === "ADD") {
                result = await apiService.create(APIPaymentStore, formDataToSend);
            } else if (postStatus === "UPDATE") {
                result = await apiService.update(APIPaymentUpdate, formDataToSend);
            } else if (postStatus === "DELETE") {
                result = await apiService.delete(APIPaymentDelete, formDataToSend);
            }

            if (result && result.success && isMounted.current) {
                showToast("Success", result.message, "success");
                handleCloseAdd();
                handleCloseDelete();
                fetchPayments();
                fetchStatistics();
            }
        } catch (error) {
            console.error("API Error:", error);
            if (isMounted.current) {
                showToast("Error", error.response?.data?.message || "Operation failed", "error");
            }
        } finally {
            if (isMounted.current) {
                setUploading(false);
            }
        }
    };

    const getStatusColor = (status) => {
        const statusMap = {
            'completed': 'success',
            'failed': 'error',
            'pending_verification': 'warning'
        };
        return statusMap[status] || 'default';
    };

    const getStatusIcon = (status) => {
        const statusMap = {
            'completed': <CheckCircle />,
            'failed': <ErrorIcon />,
            'pending_verification': <Pending />
        };
        return statusMap[status] || <ReceiptIcon />;
    };

    const getStatusText = (status) => {
        const option = paymentStatusOptions.find(opt => opt.id === status);
        return option ? option.name : status;
    };

    const getMethodIcon = (method) => {
        const option = paymentMethodOptions.find(opt => opt.id === method);
        return option?.icon || <AttachMoney />;
    };

    const getMethodText = (method) => {
        const option = paymentMethodOptions.find(opt => opt.id === method);
        return option ? option.name : method;
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-UG', {
            style: 'currency',
            currency: 'UGX',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    if (permissionLoading) {
        return <LoadingState message="Loading permissions..." variant="medical" size="large" fullPage />;
    }

    if (loading) {
        return (
            <LoadingState
                message="Loading Payment Data..."
                variant="medical"
                size="large"
                fullPage
            />
        );
    }

    if (error) {
        return (
            <ErrorState
                error={error}
                onRetry={fetchPayments}
                title="Unable to Load Payment Data"
                variant="medical"
                fullPage
                retryText="Retry Loading"
            />
        );
    }

    return (
        <Container maxWidth="xl" sx={{ py: 3 }}>
            {/* Statistics Cards */}
            {statistics && (
                <Grid container spacing={3} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Total Payments</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                                        {statistics.total_payments || 0}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.primary.light, width: 56, height: 56 }}>
                                    <ReceiptLong sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Total Amount</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.success.main }}>
                                        {formatCurrency(statistics.total_amount || 0)}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.success.light, width: 56, height: 56 }}>
                                    <AttachMoney sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Completed</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.info.main }}>
                                        {formatCurrency(statistics.completed_amount || 0)}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.info.light, width: 56, height: 56 }}>
                                    <CheckCircle sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper elevation={2} sx={{ p: 2, borderRadius: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box>
                                    <Typography variant="h6" color="text.secondary">Pending</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: theme.palette.warning.main }}>
                                        {formatCurrency(statistics.pending_amount || 0)}
                                    </Typography>
                                </Box>
                                <Avatar sx={{ bgcolor: theme.palette.warning.light, width: 56, height: 56 }}>
                                    <Pending sx={{ fontSize: 32 }} />
                                </Avatar>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            )}

            <Paper elevation={2} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 'bold',
                        color: theme.palette.primary.main,
                        flexShrink: 0
                    }}>
                        Payment History ({recordsCount(pageState.pageData.length)} Total)
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                        {hasPermission('ADD') && (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<AddIcon />}
                                onClick={handleOpenAdd}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                Record Payment
                            </Button>
                        )}
                        
                        {hasPermission('VIEW') && (
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<FilterIcon />}
                                onClick={handlefilterOptions}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                View Options
                            </Button>
                        )}
                        
                        {hasPermission('EXPORT') && (
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<GetApp />}
                                onClick={handleExportClick}
                                sx={{ textTransform: 'none', borderRadius: '8px' }}
                            >
                                Export Data
                            </Button>
                        )}
                        
                        <Button
                            variant="outlined"
                            color="info"
                            startIcon={<RefreshIcon />}
                            onClick={() => {
                                fetchPayments();
                                fetchStatistics();
                            }}
                            sx={{ textTransform: 'none', borderRadius: '8px' }}
                        >
                            Refresh
                        </Button>
                    </Box>

                    <Paper sx={{
                        width: '300px',
                        p: '2px 8px',
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        borderRadius: '8px',
                        background: theme.palette.primary.light
                    }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Search payments..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{
                                startAdornment: <Search sx={{ mr: 1, color: 'white' }} />,
                                sx: {
                                    '& fieldset': { border: 'none' },
                                    fontSize: '0.875rem',
                                    color: 'white',
                                    '& input': {
                                        color: 'white',
                                        '&::placeholder': {
                                            color: 'rgba(255, 255, 255, 0.7)',
                                            opacity: 1
                                        }
                                    }
                                }
                            }}
                            size="small"
                        />
                    </Paper>
                </Box>

                {/* Active Filters */}
                {(filters.payment_status || filters.payment_method || filters.tenant_id || 
                  filters.property_id || filters.date_from || filters.date_to || 
                  filters.min_amount || filters.max_amount) && (
                    <Box sx={{ 
                        display: 'flex', 
                        gap: 1, 
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        mt: 2,
                        pt: 2,
                        borderTop: '1px solid',
                        borderColor: 'divider'
                    }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                            Active filters:
                        </Typography>
                        {filters.payment_status && (
                            <Chip
                                label={`Status: ${getStatusText(filters.payment_status)}`}
                                onDelete={() => setFilters(prev => ({ ...prev, payment_status: '' }))}
                                color={getStatusColor(filters.payment_status)}
                                variant="outlined"
                            />
                        )}
                        {filters.payment_method && (
                            <Chip
                                label={`Method: ${getMethodText(filters.payment_method)}`}
                                onDelete={() => setFilters(prev => ({ ...prev, payment_method: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        {filters.tenant_id && (
                            <Chip
                                label={`Tenant ID: ${filters.tenant_id}`}
                                onDelete={() => setFilters(prev => ({ ...prev, tenant_id: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        {filters.date_from && (
                            <Chip
                                label={`From: ${filters.date_from}`}
                                onDelete={() => setFilters(prev => ({ ...prev, date_from: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        {filters.date_to && (
                            <Chip
                                label={`To: ${filters.date_to}`}
                                onDelete={() => setFilters(prev => ({ ...prev, date_to: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        {filters.min_amount && (
                            <Chip
                                label={`Min: ${formatCurrency(filters.min_amount)}`}
                                onDelete={() => setFilters(prev => ({ ...prev, min_amount: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        {filters.max_amount && (
                            <Chip
                                label={`Max: ${formatCurrency(filters.max_amount)}`}
                                onDelete={() => setFilters(prev => ({ ...prev, max_amount: '' }))}
                                color="primary"
                                variant="outlined"
                            />
                        )}
                        <Button
                            size="small"
                            onClick={clearFilters}
                            startIcon={<CloseIcon />}
                            sx={{ ml: 1 }}
                        >
                            Clear All
                        </Button>
                    </Box>
                )}
            </Paper>

            {/* Export Menu */}
            <Menu
                anchorEl={exportAnchorEl}
                open={Boolean(exportAnchorEl)}
                onClose={handleExportClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={handleExportExcel} sx={{ gap: 1 }}>
                    <TableChart fontSize="small" color="success" />
                    Export to Excel (.xlsx)
                </MenuItem>
                <MenuItem onClick={handleExportPDF} sx={{ gap: 1 }}>
                    <PictureAsPdf fontSize="small" color="error" />
                    Export to PDF (.pdf)
                </MenuItem>
            </Menu>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <Paper elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow sx={{
                                    backgroundColor: theme.palette.primary.main,
                                    '& th': {
                                        color: 'white',
                                        fontWeight: 'bold',
                                        fontSize: '0.95rem'
                                    }
                                }}>
                                    <TableCell>#</TableCell>
                                    <TableCell>Payment ID</TableCell>
                                    <TableCell>Tenant</TableCell>
                                    <TableCell>Amount (UGX)</TableCell>
                                    <TableCell>Payment Method</TableCell>
                                    <TableCell>Payment Date</TableCell>
                                    <TableCell>Reference</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell align="center">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((record, index) => (
                                    <TableRow
                                        key={record.id || index}
                                        hover
                                        sx={{
                                            '&:nth-of-type(odd)': {
                                                backgroundColor: theme.palette.action.hover
                                            }
                                        }}
                                    >
                                        <TableCell>
                                            <Chip
                                                label={page * rowsPerPage + index + 1}
                                                color="primary"
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                label={record.payment_id}
                                                color="info"
                                                size="small"
                                                variant="outlined"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Box>
                                                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                                    {record.tenant_name}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                    {record.tenant_phone}
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: theme.palette.success.main }}>
                                                {formatCurrency(record.amount)}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                icon={getMethodIcon(record.payment_method)}
                                                label={getMethodText(record.payment_method)}
                                                size="small"
                                                variant="outlined"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            {new Date(record.payment_date).toLocaleDateString()}
                                        </TableCell>
                                        <TableCell>
                                            {record.transaction_reference ? (
                                                <Tooltip title={record.transaction_reference}>
                                                    <Typography variant="caption" sx={{ 
                                                        maxWidth: 120, 
                                                        overflow: 'hidden', 
                                                        textOverflow: 'ellipsis',
                                                        display: 'block'
                                                    }}>
                                                        {record.transaction_reference}
                                                    </Typography>
                                                </Tooltip>
                                            ) : '-'}
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                icon={getStatusIcon(record.payment_status)}
                                                label={getStatusText(record.payment_status)}
                                                color={getStatusColor(record.payment_status)}
                                                size="small"
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            {hasPermission('VIEW') && (
                                                <Tooltip title="View Details">
                                                    <IconButton
                                                        edge="end"
                                                        onClick={() => handleOpenView(record)}
                                                        color="primary"
                                                    >
                                                        <ViewIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {hasPermission('PRINT') && (
                                                <Tooltip title="Print Receipt">
                                                    <IconButton
                                                        onClick={() => handlePrint(record)}
                                                        color="info"
                                                        size="small"
                                                    >
                                                        <PrintIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {record.receipt_url && (
                                                <Tooltip title="View Receipt">
                                                    <IconButton
                                                        onClick={() => handleViewReceipt(record)}
                                                        color="secondary"
                                                        size="small"
                                                    >
                                                        <PictureAsPdf />
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {record.payment_status === 'pending_verification' && hasPermission('EDIT') && (
                                                <Tooltip title="Verify Payment">
                                                    <IconButton
                                                        onClick={() => handleVerifyPayment(record)}
                                                        color="warning"
                                                        size="small"
                                                    >
                                                        <VerifiedUser />
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {hasPermission('EDIT') && (
                                                <Tooltip title="Edit">
                                                    <IconButton
                                                        edge="end"
                                                        onClick={() => handleOpenEdit(record)}
                                                        color="secondary"
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {hasPermission('DELETE') && (
                                                <Tooltip title="Delete">
                                                    <IconButton
                                                        edge="end"
                                                        onClick={() => handleOpenDelete(record)}
                                                        color="error"
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50, 100]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{ mt: 2 }}
                    />

                    {filteredData.length === 0 && (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            py: 8,
                            color: 'text.secondary'
                        }}>
                            <ReceiptLong sx={{ fontSize: 60, mb: 2 }} />
                            <Typography variant="h6">No payments found</Typography>
                            <Typography variant="body2">Try adjusting your search query</Typography>
                        </Box>
                    )}
                </Paper>
            </motion.div>

            {/* Filter Options Dialog - Prevent click outside */}
            <Dialog
                open={filterOptions}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseOptions();
                    }
                }}
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Filter Options</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<RefreshIcon />}
                            onClick={clearFilters}
                        >
                            Show All Payments
                        </Button>

                        <Divider>OR</Divider>

                        <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>
                            Filter Payments
                        </Typography>

                        <Box>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Payment Status</InputLabel>
                                    <Select
                                        name="payment_status"
                                        value={filters.payment_status}
                                        onChange={handleFilterChange}
                                        label="Payment Status"
                                    >
                                        <MenuItem value="">All Status</MenuItem>
                                        {paymentStatusOptions.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Payment Method</InputLabel>
                                    <Select
                                        name="payment_method"
                                        value={filters.payment_method}
                                        onChange={handleFilterChange}
                                        label="Payment Method"
                                    >
                                        <MenuItem value="">All Methods</MenuItem>
                                        {paymentMethodOptions.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Property</InputLabel>
                                    <Select
                                        name="property_id"
                                        value={filters.property_id}
                                        onChange={handleFilterChange}
                                        label="Property"
                                    >
                                        <MenuItem value="">All Properties</MenuItem>
                                        {properties.map((property) => (
                                            <MenuItem key={property.id} value={property.id}>
                                                {property.property_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Date From"
                                    name="date_from"
                                    type="date"
                                    value={filters.date_from}
                                    onChange={handleFilterChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Date To"
                                    name="date_to"
                                    type="date"
                                    value={filters.date_to}
                                    onChange={handleFilterChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Min Amount (UGX)"
                                    name="min_amount"
                                    type="number"
                                    value={filters.min_amount}
                                    onChange={handleFilterChange}
                                />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Max Amount (UGX)"
                                    name="max_amount"
                                    type="number"
                                    value={filters.max_amount}
                                    onChange={handleFilterChange}
                                />
                            </Grid>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseOptions} variant="contained">
                        Close
                    </Button>
                    <Button onClick={applyFilters} color="primary" variant="contained">
                        Apply Filters
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Add/Edit Payment Dialog - Prevent click outside */}
            <Dialog
                open={openAdd}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseAdd();
                    }
                }}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                scroll="paper"
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>
                    <b>{postStatus === "ADD" ? "Record New Payment" : "Edit Payment"}</b>
                </DialogTitle>
                <DialogContent>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <Box>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}>
                                    Payment Information
                                </Typography>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth required>
                                    <InputLabel>Select Tenant *</InputLabel>
                                    <Select
                                        name="tenant_id"
                                        value={formData.tenant_id}
                                        onChange={handleInputChange}
                                        label="Select Tenant *"
                                    >
                                        <MenuItem value="">Select a tenant</MenuItem>
                                        {tenants.map((tenant) => (
                                            <MenuItem key={tenant.id} value={tenant.id}>
                                                {tenant.full_name} - {tenant.phone_number}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Select Assignment (Optional)</InputLabel>
                                    <Select
                                        name="assignment_id"
                                        value={formData.assignment_id}
                                        onChange={handleInputChange}
                                        label="Select Assignment (Optional)"
                                    >
                                        <MenuItem value="">No specific assignment</MenuItem>
                                        {assignments.map((assignment) => (
                                            <MenuItem key={assignment.id} value={assignment.id}>
                                                {assignment.apartment_number} - {assignment.property_name} (UGX {assignment.agreed_rent_amount})
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Payment Date & Time *"
                                    name="payment_date"
                                    type="datetime-local"
                                    value={formData.payment_date}
                                    onChange={handleInputChange}
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <CalendarToday />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Amount (UGX) *"
                                    name="amount"
                                    type="number"
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    required
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AttachMoney />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth required>
                                    <InputLabel>Payment Method *</InputLabel>
                                    <Select
                                        name="payment_method"
                                        value={formData.payment_method}
                                        onChange={handleInputChange}
                                        label="Payment Method *"
                                    >
                                        <MenuItem value="">Select method</MenuItem>
                                        {paymentMethodOptions.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    {item.icon}
                                                    {item.name}
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Transaction Reference"
                                    name="transaction_reference"
                                    value={formData.transaction_reference}
                                    onChange={handleInputChange}
                                    placeholder="Check number, transaction ID, etc."
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <ReceiptIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid><br/>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Payment Status</InputLabel>
                                    <Select
                                        name="payment_status"
                                        value={formData.payment_status}
                                        onChange={handleInputChange}
                                        label="Payment Status"
                                    >
                                        {paymentStatusOptions.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    {item.icon}
                                                    {item.name}
                                                </Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid><br/>
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1, mt: 2 }}>
                                    Receipt Upload (Optional)
                                </Typography>
                                <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<CloudUpload />}
                                    sx={{ mb: 1 }}
                                >
                                    Upload Receipt PDF
                                    <input
                                        type="file"
                                        hidden
                                        accept="application/pdf"
                                        onChange={handleFileChange}
                                    />
                                </Button><br/>
                                {formData.receipt_file && (
                                    <Typography variant="caption" display="block" color="success.main">
                                        File selected: {formData.receipt_file.name}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Notes"
                                    name="notes"
                                    value={formData.notes}
                                    onChange={handleInputChange}
                                    multiline
                                    rows={3}
                                    placeholder="Additional information about the payment..."
                                />
                            </Grid>
                        </Box>

                        <DialogActions sx={{ mt: 3, px: 0 }}>
                            <Button color="error" onClick={handleCloseAdd} variant="contained">
                                Cancel
                            </Button>
                            <Button type="submit" color="primary" variant="contained" disabled={uploading}>
                                {uploading ? <CircularProgress size={24} /> : (postStatus === "ADD" ? "Record Payment" : "Update Payment")}
                            </Button>
                        </DialogActions>
                    </Box>
                </DialogContent>
            </Dialog>

            {/* View Dialog - Prevent click outside */}
            <Dialog
                open={openView}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseView();
                    }
                }}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>
                    <b>Payment Details</b>
                </DialogTitle>
                <DialogContent>
                    {selectedRecord && (
                        <Box>
                            <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)} sx={{ mb: 2 }}>
                                <Tab label="Payment Info" icon={<ReceiptLong />} iconPosition="start" />
                                <Tab label="Tenant Info" icon={<Person />} iconPosition="start" />
                                <Tab label="Assignment Info" icon={<AssignmentInd />} iconPosition="start" />
                            </Tabs>

                            {activeTab === 0 && (
                                <Box sx={{ p: 2 }}>
                                    <Box>
                                        <Grid item xs={12}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Typography variant="h6" color="primary">
                                                    {selectedRecord.payment_id}
                                                </Typography>
                                                <Chip
                                                    icon={getStatusIcon(selectedRecord.payment_status)}
                                                    label={getStatusText(selectedRecord.payment_status)}
                                                    color={getStatusColor(selectedRecord.payment_status)}
                                                />
                                            </Box>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Amount:</b> {formatCurrency(selectedRecord.amount)}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Payment Method:</b> {getMethodText(selectedRecord.payment_method)}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Payment Date:</b> {new Date(selectedRecord.payment_date).toLocaleString()}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Transaction Reference:</b> {selectedRecord.transaction_reference || '-'}</Typography>
                                        </Grid><br/>
                                        {selectedRecord.notes && (
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle2"><b>Notes:</b> {selectedRecord.notes}</Typography>
                                            </Grid>
                                        )}<br/>
                                        {selectedRecord.receipt_url && (
                                            <Grid item xs={12}>
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<PictureAsPdf />}
                                                    onClick={() => handleViewReceipt(selectedRecord)}
                                                >
                                                    View Receipt
                                                </Button>
                                            </Grid>
                                        )}
                                    </Box>
                                </Box>
                            )}

                            {activeTab === 1 && (
                                <Box sx={{ p: 2 }}>
                                    <Box>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" color="primary">
                                                {selectedRecord.tenant_name}
                                            </Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Phone:</b> {selectedRecord.tenant_phone}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Email:</b> {selectedRecord.tenant_email || '-'}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2"><b>Emergency Contact:</b> {selectedRecord.emergency_contact_name || '-'}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2"><b>Emergency Phone:</b> {selectedRecord.emergency_contact_phone || '-'}</Typography>
                                        </Grid>
                                    </Box>
                                </Box>
                            )}

                            {activeTab === 2 && selectedRecord.assignment_id && (
                                <Box sx={{ p: 2 }}>
                                    <Box>
                                        <Grid item xs={12}>
                                            <Typography variant="h6" color="primary">
                                                {selectedRecord.property_name}
                                            </Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Apartment:</b> {selectedRecord.apartment_number}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle2"><b>Floor:</b> {selectedRecord.floor_number}</Typography>
                                        </Grid><br/>
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2"><b>Monthly Rent:</b> {formatCurrency(selectedRecord.agreed_rent_amount || 0)}</Typography>
                                        </Grid>
                                    </Box>
                                </Box>
                            )}

                            {activeTab === 2 && !selectedRecord.assignment_id && (
                                <Box sx={{ p: 2, textAlign: 'center' }}>
                                    <Typography variant="body2" color="text.secondary">
                                        No assignment associated with this payment
                                    </Typography>
                                </Box>
                            )}

                            <Grid item xs={12}>
                                <Typography variant="h6" color="primary" gutterBottom sx={{ mt: 2 }}>
                                    System Information
                                </Typography>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2"><b>Created Date:</b> {formatCreatedAtDate(selectedRecord.created_at)}</Typography>
                            </Grid><br/>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="subtitle2"><b>Last Updated:</b> {formatCreatedAtDate(selectedRecord.updated_at)}</Typography>
                            </Grid>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseView} variant="contained">
                        Close
                    </Button>
                    {hasPermission('PRINT') && selectedRecord && (
                        <Button onClick={() => handlePrint(selectedRecord)} color="info" variant="contained">
                            <Print sx={{ mr: 1 }} /> Print Receipt
                        </Button>
                    )}
                </DialogActions>
            </Dialog>

            {/* Verify Payment Dialog - Prevent click outside */}
            <Dialog
                open={verifyDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseVerify();
                    }
                }}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="sm"
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Verify Payment</DialogTitle>
                <DialogContent>
                    <Box sx={{ p: 2 }}>
                        <Typography variant="body1" gutterBottom>
                            Verify payment from <strong>{selectedRecord?.tenant_name}</strong> for <strong>{formatCurrency(selectedRecord?.amount)}</strong>
                        </Typography>
                        <Alert severity="info" sx={{ mb: 2 }}>
                            Marking this payment as verified will confirm that the payment has been successfully processed.
                        </Alert>
                        <TextField
                            fullWidth
                            label="Verification Notes (Optional)"
                            value={verificationNotes}
                            onChange={(e) => setVerificationNotes(e.target.value)}
                            multiline
                            rows={3}
                            placeholder="Add any notes about the verification process..."
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseVerify} variant="contained">
                        Cancel
                    </Button>
                    <Button onClick={handleVerifySubmit} color="success" variant="contained">
                        Verify Payment
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Receipt Preview Dialog - Prevent click outside */}
            <Dialog
                open={receiptPreviewOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseReceiptPreview();
                    }
                }}
                TransitionComponent={Transition}
                fullWidth
                maxWidth="md"
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>
                    <b>Receipt Preview</b>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ height: '70vh', width: '100%' }}>
                        <iframe
                            src={receiptUrl}
                            title="Receipt Preview"
                            style={{ width: '100%', height: '100%', border: 'none' }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseReceiptPreview} variant="contained">
                        Close
                    </Button>
                    {receiptUrl && (
                        <Button
                            component="a"
                            href={receiptUrl}
                            download
                            color="primary"
                            variant="contained"
                            startIcon={<Download />}
                        >
                            Download
                        </Button>
                    )}
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog - Prevent click outside */}
            <Dialog
                open={openDelete}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseDelete();
                    }
                }}
                TransitionComponent={Transition}
                disableEscapeKeyDown
            >
                <DialogTitle sx={{ textAlign: 'center' }}>Delete Payment Record</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                        Are you sure you want to delete this payment record?
                    </Typography>
                    {selectedRecord && (
                        <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                            {selectedRecord.payment_id}
                            <Box sx={{ mt: 1 }}>
                                <Chip
                                    icon={<Person />}
                                    label={selectedRecord.tenant_name}
                                    color="primary"
                                    variant="outlined"
                                    size="small"
                                />
                                <Chip
                                    icon={<AttachMoney />}
                                    label={formatCurrency(selectedRecord.amount)}
                                    color="success"
                                    variant="outlined"
                                    size="small"
                                    sx={{ ml: 1 }}
                                />
                            </Box>
                        </Typography>
                    )}
                    <Typography variant="body2" color="error" sx={{ textAlign: 'center', mt: 2 }}>
                        Warning: This action cannot be undone!
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={handleCloseDelete} variant="contained">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} color="primary" variant="contained">
                        Confirm Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default PaymentHistory;